import _ from 'lodash'
import {
  FETCH_USER,
  FETCH_PRIVILEGE_PAGES,
  REDIRECT_SHARED_LINK
} from '../actions/actionTypes'
import {
  setNavigationPages,
  putSharedLink,
  invokeRedirect
} from '../actions'
import confUtil from '../../lib/confUtil'
import { REDIRECT_TIMEOUT } from '../constants/proposalTypes'

const communicator = store => next => action => {
  switch (action.type) {
    case FETCH_USER: {
      const isInternalUser = action.payload.simulated
      const env = isInternalUser ? 'internal' : 'external'
      const { page } = store.getState() || {}
      const envConf = page.envConf
      next(
        putSharedLink({
          scmHomepage: confUtil.getAbsUrlByPath(envConf)('scmHomepage', env),
          supplierRanking: confUtil.getAbsUrlByPath(envConf)('supplierRanking', env),
          moreAnnouncements: confUtil.getAbsUrlByPath(envConf)('moreAnnouncements', env),
          scmStockQtyAdjust: confUtil.getAbsUrlByPath(envConf)('scmStockQtyAdjust', env),
          scmProductCostPrice: confUtil.getAbsUrlByPath(envConf)('scmProductCostPrice', env),
          scmProposalQuery: confUtil.getAbsUrlByPath(envConf)('scmProposalQuery', env),
          scmPMPortal: confUtil.getAbsUrlByPath(envConf)('scmPMPortal', env),
          scmLogin: isInternalUser
            ? confUtil.getAbsUrl(envConf)('scmProposalLookup')
            : confUtil.getAbsUrl(envConf)('login'),
          scmProposalLookup: confUtil.getAbsUrl(envConf)('scmProposalLookup'),
          scmApiKeyIntroduction: confUtil.getAbsUrlByPath(envConf)('scmApiKeyIntroduction', env),
          scmApiKeyQuery: confUtil.getAbsUrlByPath(envConf)('scmApiKeyQuery', env),
          buyGdSale: confUtil.getAbsUrl(envConf)('buyGdSale'),
          scmQueryCampaign: confUtil.getAbsUrlByPath(envConf)('scmQueryCampaign', env),
          scmCreateInventory: confUtil.getAbsUrlByPath(envConf)('scmCreateInventory', env)
        })
      )
      return next(action)
    }

    case FETCH_PRIVILEGE_PAGES: {
      // 如果有錯誤，則預設頁面，運籌中心
      if (action.error) {
        next(setNavigationPages(action.payload.errorData.args.navigationPages))
        return next(action)
      }
      break
    }

    case REDIRECT_SHARED_LINK: {
      const { key, timeout = REDIRECT_TIMEOUT } = action.payload || {}
      const state = store.getState() || {}
      const sharedLink = _.get(state, 'supplier.sharedLink') || {}
      const redirectUrl = _.get(sharedLink, key)
      if (redirectUrl) {
        return next(invokeRedirect({ url: redirectUrl, timeout }))
      } else {
        console.debug(`middleware REDIRECT_SHARED_LINK failed, link not found, key: ${key}`)
      }
    }
  }

  return next(action)
}

export default communicator
